export default __webpack_public_path__ + "static/media/7.be2a1db1.jpeg";